<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/fondo5.jpg"
  style="background-image: url('assets/img/fondo5.jpg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white mt-100">
          <h3 style="color: white">
            FOTOTECA
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="welcome-section pb-100 pb-md-60 pb-sm-40 pt-80 bg-offwhite" style="background-image: url('/assets/img/fondo-rosario.png'); background-size: cover;
    background-position: center;">
  <div class="container">
      <div class="row">
          <!-- Start Section title -->
          <div class="col-lg-6 m-auto text-center">
              <div class="section-title-wrap">
                  <h2>RECOPILACIÓN DE FOTOGRAFÍAS DEL CUSCO ANTIGUO DECADA 40 Y 50</h2>
              </div>
          </div><!-- End Section title -->
      </div>
      <div class="row">
          <div class="col-12">
              <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td><a href="assets/pdf/fototeca/cusco_antiguo/DECADA DE LOS 40' (2).pdf" target="_blank"> DECADA DE LOS 40' (2)</a></td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td><a href="assets/pdf/fototeca/cusco_antiguo/DECADA DE LOS 40.pdf" target="_blank"> DECADA DE LOS 40</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td><a href="assets/pdf/fototeca/cusco_antiguo/DECADA DE LOS 40'.pdf" target="_blank"> DECADA DE LOS 40'</a></td>
                    </tr>
                    <tr>
                      <th scope="row">4</th>
                      <td><a href="assets/pdf/fototeca/cusco_antiguo/DECADA DE LOS 50.pdf" target="_blank"> DECADA DE LOS 50</a></td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td><a href="assets/pdf/fototeca/cusco_antiguo/DECADA DEN LOS 40'.pdf" target="_blank"> DECADA DEN LOS 40'</a></td>
                    </tr>
                  </tbody>
                </table>
          </div>
      </div>
  </div>
</section>


<div class="page-wrapper"
  style="background-image: url('/assets/img/fondo-leyenda-catalogacion.png'); background-size: cover; background-position: center;">
  <div class="accordion-content-wrapper mt-80 mt-md-80 mt-sm-50 mb-80 mb-md-80 mb-sm-50">
    <div class="container">
      <div class="row">
          <!-- Start Section title -->
          <div class="col-lg-6 m-auto text-center">
              <div class="section-title-wrap">
                  <h2>RECOPILACIÓN DE FOTOGRAFÍAS DEL CUSCO 2003 POR SECTORES</h2>
              </div>
          </div><!-- End Section title -->
      </div>
      <div class="row">
        <div class="col-12">
          <div class="product-description-review">
            <ul class="nav nav-tabs desc-review-tab-menu" id="desc-review-tab" role="tablist">
              <li><a id="profile-tab" data-toggle="tab" href="#reviewContent" class="active">SG-1</a></li>
              <li><a class="" id="desc-tab" data-toggle="tab" href="#descriptionContent" role="tab" aria-selected="false">SG-02</a></li>
              <li><a class="" id="desc-tab" data-toggle="tab" href="#descriptionContent1" role="tab" aria-selected="false">SG-03</a></li>
              <li><a class="" id="desc-tab" data-toggle="tab" href="#descriptionContent2" role="tab" aria-selected="false">SG-04</a></li>
              <li><a class="" id="desc-tab" data-toggle="tab" href="#descriptionContent3" role="tab" aria-selected="false">SG-05</a></li>
              <li><a class="" id="desc-tab" data-toggle="tab" href="#descriptionContent4" role="tab" aria-selected="false">SG-06</a></li>
              <li><a class="" id="desc-tab" data-toggle="tab" href="#descriptionContent5" role="tab" aria-selected="false">SG-07</a></li>
              <li><a class="" id="desc-tab" data-toggle="tab" href="#descriptionContent6" role="tab" aria-selected="false">SG-08</a></li>
              <li><a class="" id="desc-tab" data-toggle="tab" href="#descriptionContent7" role="tab" aria-selected="false">SG-09</a></li>
            </ul><!-- Product Description Tab Content -->
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade active show" id="reviewContent">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01  2003 MZ. 85 Nº 1468-1392.pdf" target="_blank"> SG-01  2003 MZ. 85 Nº 1468-1392</a></td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01  2003 MZ.32 Nº 1634- 1716.pdf" target="_blank"> SG-01  2003 MZ.32 Nº 1634- 1716</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ. 11 Nº 0190-1715.pdf" target="_blank"> SG-01 2003 MZ. 11 Nº 0190-1715</a></td>
                    </tr>
                    <tr>
                      <th scope="row">4</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ. 30 Nº 1279-1280.pdf" target="_blank"> SG-01 2003 MZ. 30 Nº 1279-1280</a></td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ. 31 Nº 1279.pdf" target="_blank"> SG-01 2003 MZ. 31 Nº 1279</a></td>
                    </tr>
                    <tr>
                      <th scope="row">6</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ. 35 Nº 1638-1642.pdf" target="_blank"> SG-01 2003 MZ. 35 Nº 1638-1642</a></td>
                    </tr>
                    <tr>
                      <th scope="row">7</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ. 47 Nº 1849.pdf" target="_blank"> SG-01 2003 MZ. 47 Nº 1849</a></td>
                    </tr>
                    <tr>
                      <th scope="row">8</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ. 62 Nº 1713-1712.pdf" target="_blank"> SG-01 2003 MZ. 62 Nº 1713-1712</a></td>
                    </tr>
                    <tr>
                      <th scope="row">9</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ. 72 Nº 1280.pdf" target="_blank"> SG-01 2003 MZ. 72 Nº 1280</a></td>
                    </tr>
                    <tr>
                      <th scope="row">10</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ. 73 Nº 1280.pdf" target="_blank"> SG-01 2003 MZ. 73 Nº 1280</a></td>
                    </tr>
                    <tr>
                      <th scope="row">11</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ. 86 Nº 1392.pdf" target="_blank"> SG-01 2003 MZ. 86 Nº 1392</a></td>
                    </tr>
                    <tr>
                      <th scope="row">12</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ. 87 Nº 1855.pdf" target="_blank"> SG-01 2003 MZ. 87 Nº 1855</a></td>
                    </tr>
                    <tr>
                      <th scope="row">13</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ. 88 Nº 1854-1855.pdf" target="_blank"> SG-01 2003 MZ. 88 Nº 1854-1855</a></td>
                    </tr>
                    <tr>
                      <th scope="row">14</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.10 Nº 1400-1715-1795.pdf" target="_blank"> SG-01 2003 MZ.10 Nº 1400-1715-1795</a></td>
                    </tr>
                    <tr>
                      <th scope="row">15</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.12 Nº 1399.pdf" target="_blank"> SG-01 2003 MZ.12 Nº 1399</a></td>
                    </tr>
                    <tr>
                      <th scope="row">16</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.13 Nº 1472.pdf" target="_blank"> SG-01 2003 MZ.13 Nº 1472</a></td>
                    </tr>
                    <tr>
                      <th scope="row">17</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.14 Nº 1472.pdf" target="_blank"> SG-01 2003 MZ.14 Nº 1472</a></td>
                    </tr>
                    <tr>
                      <th scope="row">18</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.15 Nº 1472.pdf" target="_blank"> SG-01 2003 MZ.15 Nº 1472</a></td>
                    </tr>
                    <tr>
                      <th scope="row">19</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.16 Nº 1476.pdf" target="_blank"> SG-01 2003 MZ.16 Nº 1476</a></td>
                    </tr>
                    <tr>
                      <th scope="row">20</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.17 Nº 1866.pdf" target="_blank"> SG-01 2003 MZ.17 Nº 1866</a></td>
                    </tr>
                    <tr>
                      <th scope="row">21</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.18 Nº 1459-1227.pdf" target="_blank"> SG-01 2003 MZ.18 Nº 1459-1227</a></td>
                    </tr>
                    <tr>
                      <th scope="row">22</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.19 Nº 1637-1459.pdf" target="_blank"> SG-01 2003 MZ.19 Nº 1637-1459</a></td>
                    </tr>
                    <tr>
                      <th scope="row">23</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.33 Nº 1634.pdf" target="_blank"> SG-01 2003 MZ.33 Nº 1634</a></td>
                    </tr>
                    <tr>
                      <th scope="row">24</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.35 Nº 1402-1401.pdf" target="_blank"> SG-01 2003 MZ.35 Nº 1402-1401</a></td>
                    </tr>
                    <tr>
                      <th scope="row">25</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.36 Nº 1227-1402.pdf" target="_blank"> SG-01 2003 MZ.36 Nº 1227-1402</a></td>
                    </tr>
                    <tr>
                      <th scope="row">26</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.37 Nº 1715.pdf" target="_blank"> SG-01 2003 MZ.37 Nº 1715</a></td>
                    </tr>
                    <tr>
                      <th scope="row">27</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.38 Nº 1715-1621.pdf" target="_blank"> SG-01 2003 MZ.38 Nº 1715-1621</a></td>
                    </tr>
                    <tr>
                      <th scope="row">28</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.53 Nº 1385.pdf" target="_blank"> SG-01 2003 MZ.53 Nº 1385</a></td>
                    </tr>
                    <tr>
                      <th scope="row">29</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.54 Nº 1227-1399.pdf" target="_blank"> SG-01 2003 MZ.54 Nº 1227-1399</a></td>
                    </tr>
                    <tr>
                      <th scope="row">30</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.55 Nº 1399.pdf" target="_blank"> SG-01 2003 MZ.55 Nº 1399</a></td>
                    </tr>
                    <tr>
                      <th scope="row">31</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.56 Nº 1476-1472.pdf" target="_blank"> SG-01 2003 MZ.56 Nº 1476-1472</a></td>
                    </tr>
                    <tr>
                      <th scope="row">32</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.57 Nº 1476.pdf" target="_blank"> SG-01 2003 MZ.57 Nº 1476</a></td>
                    </tr>
                    <tr>
                      <th scope="row">33</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.59 Nº 1866-1474-1382.pdf" target="_blank"> SG-01 2003 MZ.59 Nº 1866-1474-1382</a></td>
                    </tr>
                    <tr>
                      <th scope="row">34</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.60 Nº 1402.pdf" target="_blank"> SG-01 2003 MZ.60 Nº 1402</a></td>
                    </tr>
                    <tr>
                      <th scope="row">35</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.61 Nº 1402.pdf" target="_blank"> SG-01 2003 MZ.61 Nº 1402</a></td>
                    </tr>
                    <tr>
                      <th scope="row">36</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.62 Nº 1227- 1401.pdf" target="_blank"> SG-01 2003 MZ.62 Nº 1227- 1401</a></td>
                    </tr>
                    <tr>
                      <th scope="row">37</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.63 Nº 1401-1396-1866-1227-1273.pdf" target="_blank"> SG-01 2003 MZ.63 Nº 1401-1396-1866-1227-1273</a></td>
                    </tr>
                    <tr>
                      <th scope="row">38</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.64 Nº 1274-1795.pdf" target="_blank"> SG-01 2003 MZ.64 Nº 1274-1795</a></td>
                    </tr>
                    <tr>
                      <th scope="row">39</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 MZ.65 Nº 1795-1383-1957-1383-1274.pdf" target="_blank"> SG-01 2003 MZ.65 Nº 1795-1383-1957-1383-1274</a></td>
                    </tr>
                    <tr>
                      <th scope="row">40</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-01 NUCLEO DEL CH/SG-01 2003 Nº 1150 Y 3822.pdf" target="_blank"> SG-01 2003 Nº 1150 Y 3822</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="tab-pane fade" id="descriptionContent">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ. 03 Nº 1795-1957-0190.pdf" target="_blank"> SG-02 2003 MZ. 03 Nº 1795-1957-0190</a></td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ. 09 Nº 1470-1400-1957-1795.pdf" target="_blank"> SG-02 2003 MZ. 09 Nº 1470-1400-1957-1795</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ. 37 Nº 1638-1642.pdf" target="_blank"> SG-02 2003 MZ. 37 Nº 1638-1642</a></td>
                    </tr>
                    <tr>
                      <th scope="row">4</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ. 38 Nº 1638.pdf" target="_blank"> SG-02 2003 MZ. 38 Nº 1638</a></td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.01 Nº 1795-1458-1462-0190.pdf" target="_blank"> SG-02 2003 MZ.01 Nº 1795-1458-1462-0190</a></td>
                    </tr>
                    <tr>
                      <th scope="row">6</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.02 Nº1458-1793.pdf" target="_blank"> SG-02 2003 MZ.02 Nº1458-1793</a></td>
                    </tr>
                    <tr>
                      <th scope="row">7</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.03 Nº1463.pdf" target="_blank"> SG-02 2003 MZ.03 Nº1463</a></td>
                    </tr>
                    <tr>
                      <th scope="row">8</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.4 Nº 1463.pdf" target="_blank"> SG-02 2003 MZ.4 Nº 1463</a></td>
                    </tr>
                    <tr>
                      <th scope="row">9</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.05 Nº 1394-1278.pdf" target="_blank"> SG-02 2003 MZ.05 Nº 1394-1278</a></td>
                    </tr>
                    <tr>
                      <th scope="row">10</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.05 Nº1795-1957-1470.pdf" target="_blank"> SG-02 2003 MZ.05 Nº1795-1957-1470</a></td>
                    </tr>
                    <tr>
                      <th scope="row">11</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.06 Nº 1469-1470.pdf" target="_blank"> SG-02 2003 MZ.06 Nº 1469-1470</a></td>
                    </tr>
                    <tr>
                      <th scope="row">12</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.07 1957-0190-1469.pdf" target="_blank"> SG-02 2003 MZ.07 1957-0190-1469</a></td>
                    </tr>
                    <tr>
                      <th scope="row">13</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.08 Nº 1470.pdf" target="_blank"> SG-02 2003 MZ.08 Nº 1470</a></td>
                    </tr>
                    <tr>
                      <th scope="row">14</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.39 Nº 1621.pdf" target="_blank"> SG-02 2003 MZ.39 Nº 1621</a></td>
                    </tr>
                    <tr>
                      <th scope="row">15</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.40 Nº 1621-1622.pdf" target="_blank"> SG-02 2003 MZ.40 Nº 1621-1622</a></td>
                    </tr>
                    <tr>
                      <th scope="row">16</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.41 Nº 1640.pdf" target="_blank"> SG-02 2003 MZ.41 Nº 1640</a></td>
                    </tr>
                    <tr>
                      <th scope="row">17</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.42 Nº 1795-1640-1957-1462.pdf" target="_blank"> SG-02 2003 MZ.42 Nº 1795-1640-1957-1462</a></td>
                    </tr>
                    <tr>
                      <th scope="row">18</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.43 Nº 1458.pdf" target="_blank"> SG-02 2003 MZ.43 Nº 1458</a></td>
                    </tr>
                    <tr>
                      <th scope="row">19</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.44 Nº 1462.pdf" target="_blank"> SG-02 2003 MZ.44 Nº 1462</a></td>
                    </tr>
                    <tr>
                      <th scope="row">20</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.45 Nº 1795-1462.pdf" target="_blank"> SG-02 2003 MZ.45 Nº 1795-1462</a></td>
                    </tr>
                    <tr>
                      <th scope="row">21</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.46 Nº 1472-1795.pdf" target="_blank"> SG-02 2003 MZ.46 Nº 1472-1795</a></td>
                    </tr>
                    <tr>
                      <th scope="row">22</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.47 Nº 1400-1957-1795-1397.pdf" target="_blank"> SG-02 2003 MZ.47 Nº 1400-1957-1795-1397</a></td>
                    </tr>
                    <tr>
                      <th scope="row">23</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.48 Nº 1715.pdf" target="_blank"> SG-02 2003 MZ.48 Nº 1715</a></td>
                    </tr>
                    <tr>
                      <th scope="row">24</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.49 Nº 1397.pdf" target="_blank"> SG-02 2003 MZ.49 Nº 1397</a></td>
                    </tr>
                    <tr>
                      <th scope="row">25</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.50 Nº 1397.pdf" target="_blank"> SG-02 2003 MZ.50 Nº 1397</a></td>
                    </tr>
                    <tr>
                      <th scope="row">26</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.51 Nº 1397-1795-1383.pdf" target="_blank"> SG-02 2003 MZ.51 Nº 1397-1795-1383</a></td>
                    </tr>
                    <tr>
                      <th scope="row">27</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 2003 MZ.52 Nº 1715.pdf" target="_blank"> SG-02 2003 MZ.52 Nº 1715</a></td>
                    </tr>
                    <tr>
                      <th scope="row">28</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 R.F. 2003 Nº3820.pdf" target="_blank"> SG-02 R.F. 2003 Nº3820</a></td>
                    </tr>
                    <tr>
                      <th scope="row">29</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 R.F. 2003 Nº3821.pdf" target="_blank"> SG-02 R.F. 2003 Nº3821</a></td>
                    </tr>
                    <tr>
                      <th scope="row">30</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-02 SAN CRISTOBAL/SG-02 SAN CRISTOBAL.pdf" target="_blank"> SG-02 SAN CRISTOBAL</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="tab-pane fade" id="descriptionContent1">
                <table class="table">
                  <tbody>

                    <tr>
                      <th scope="row">1</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-03 SANTO DOMINGO-SAN AGUSTIN/SG-03  2003 MZ. 46 Nº 1843-1845.pdf" target="_blank"> SG-03  2003 MZ. 46 Nº 1843-1845</a></td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-03 SANTO DOMINGO-SAN AGUSTIN/SG-03  2003 MZ. 53-77 Nº 1721-1719-1856.pdf" target="_blank"> SG-03  2003 MZ. 53-77 Nº 1721-1719-1856</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-03 SANTO DOMINGO-SAN AGUSTIN/SG-03 2003 MZ. 07 LIMACPAMPA GRANDE Nº 1711-1281.pdf" target="_blank"> SG-03 2003 MZ. 07 LIMACPAMPA GRANDE Nº 1711-1281</a></td>
                    </tr>
                    <tr>
                      <th scope="row">4</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-03 SANTO DOMINGO-SAN AGUSTIN/SG-03 2003 MZ. 08 Nº 1281.pdf" target="_blank"> SG-03 2003 MZ. 08 Nº 1281</a></td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-03 SANTO DOMINGO-SAN AGUSTIN/SG-03 2003 MZ. 09 Nº 1281-1720.pdf" target="_blank"> SG-03 2003 MZ. 09 Nº 1281-1720</a></td>
                    </tr>
                    <tr>
                      <th scope="row">6</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-03 SANTO DOMINGO-SAN AGUSTIN/SG-03 2003 MZ. 10 Nº 1720.pdf" target="_blank"> SG-03 2003 MZ. 10 Nº 1720</a></td>
                    </tr>
                    <tr>
                      <th scope="row">7</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-03 SANTO DOMINGO-SAN AGUSTIN/SG-03 2003 MZ. 48 Nº 1845-1849.pdf" target="_blank"> SG-03 2003 MZ. 48 Nº 1845-1849</a></td>
                    </tr>
                    <tr>
                      <th scope="row">8</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-03 SANTO DOMINGO-SAN AGUSTIN/SG-03 2003 MZ. 51 Nº 1717.pdf" target="_blank"> SG-03 2003 MZ. 51 Nº 1717</a></td>
                    </tr>
                    <tr>
                      <th scope="row">9</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-03 SANTO DOMINGO-SAN AGUSTIN/SG-03 2003 MZ. 74 Nº 1709.pdf" target="_blank"> SG-03 2003 MZ. 74 Nº 1709</a></td>
                    </tr>
                    <tr>
                      <th scope="row">10</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-03 SANTO DOMINGO-SAN AGUSTIN/SG-03 2003 MZ. 75 Nº 1717-1709.pdf" target="_blank"> SG-03 2003 MZ. 75 Nº 1717-1709</a></td>
                    </tr>
                    <tr>
                      <th scope="row">11</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-03 SANTO DOMINGO-SAN AGUSTIN/SG-03 2003 MZ. CERVECERIA Nº 1872.pdf" target="_blank"> SG-03 2003 MZ. CERVECERIA Nº 1872</a></td>
                    </tr>
                    <tr>
                      <th scope="row">12</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-03 SANTO DOMINGO-SAN AGUSTIN/SG-03 2003 MZ. W Nº 1711.pdf" target="_blank"> SG-03 2003 MZ. W Nº 1711</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="tab-pane fade" id="descriptionContent2">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ. 01 Nº 1868.pdf" target="_blank"> SG-04 2003 MZ. 01 Nº 1868</a></td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ. 03 Nº 1868.pdf" target="_blank"> SG-04 2003 MZ. 03 Nº 1868</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ. 04 Nº 1475- 1469-1795.pdf" target="_blank"> SG-04 2003 MZ. 04 Nº 1475- 1469-1795</a></td>
                    </tr>
                    <tr>
                      <th scope="row">4</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ. 04 Nº 1872.pdf" target="_blank"> SG-04 2003 MZ. 04 Nº 1872</a></td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ. 05 Nº 1865.pdf" target="_blank"> SG-04 2003 MZ. 05 Nº 1865</a></td>
                    </tr>
                    <tr>
                      <th scope="row">6</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ. 06 Nº 1857-1867.pdf" target="_blank"> SG-04 2003 MZ. 06 Nº 1857-1867</a></td>
                    </tr>
                    <tr>
                      <th scope="row">7</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ. 39 Nº 1638.pdf" target="_blank"> SG-04 2003 MZ. 39 Nº 1638</a></td>
                    </tr>
                    <tr>
                      <th scope="row">8</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ. 40 Nº 1847-1843.pdf" target="_blank"> SG-04 2003 MZ. 40 Nº 1847-1843</a></td>
                    </tr>
                    <tr>
                      <th scope="row">9</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ. 42 Nº 1865-1867.pdf" target="_blank"> SG-04 2003 MZ. 42 Nº 1865-1867</a></td>
                    </tr>
                    <tr>
                      <th scope="row">10</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ. 44 Nº 1843.pdf" target="_blank"> SG-04 2003 MZ. 44 Nº 1843</a></td>
                    </tr>
                    <tr>
                      <th scope="row">11</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ. 45 Nº 1845.pdf" target="_blank"> SG-04 2003 MZ. 45 Nº 1845</a></td>
                    </tr>
                    <tr>
                      <th scope="row">12</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ.24 Nº 1958-1957.pdf" target="_blank"> SG-04 2003 MZ.24 Nº 1958-1957</a></td>
                    </tr>
                    <tr>
                      <th scope="row">13</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ.25 Nº 1958.pdf" target="_blank"> SG-04 2003 MZ.25 Nº 1958</a></td>
                    </tr>
                    <tr>
                      <th scope="row">14</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ.26 Nº 190.pdf" target="_blank">SG-04 2003 MZ.26 Nº 190 </a></td>
                    </tr>
                    <tr>
                      <th scope="row">15</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ.27 Nº 190.pdf" target="_blank"> SG-04 2003 MZ.27 Nº 190</a></td>
                    </tr>
                    <tr>
                      <th scope="row">16</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ.28 Nº 1622-1640.pdf" target="_blank"> SG-04 2003 MZ.28 Nº 1622-1640</a></td>
                    </tr>
                    <tr>
                      <th scope="row">17</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ.30 Nº 1622.pdf" target="_blank">SG-04 2003 MZ.30 Nº 1622 </a></td>
                    </tr>
                    <tr>
                      <th scope="row">18</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ.31 Nº 1622.pdf" target="_blank"> SG-04 2003 MZ.31 Nº 1622</a></td>
                    </tr>
                    <tr>
                      <th scope="row">19</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-04 SAN BLAS-LIMACPAMPA/SG-04 2003 MZ.73 Nº 1640.pdf" target="_blank"> SG-04 2003 MZ.73 Nº 1640</a></td>
                    </tr>

                  </tbody>
                </table>
              </div>
              <div class="tab-pane fade" id="descriptionContent3">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG 05 2003 MZ.40,45,46 Nº 1393-1389.pdf" target="_blank"> SG 05 2003 MZ.40,45,46 Nº 1393-1389</a></td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ. 13 Nº1386.pdf" target="_blank"> SG-05 2003 MZ. 13 Nº1386</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ. 20.23,43 Nº 1387-1394.pdf" target="_blank"> SG-05 2003 MZ. 20.23,43 Nº 1387-1394</a></td>
                    </tr>
                    <tr>
                      <th scope="row">4</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ. 99 (NO DEFINIDO).pdf" target="_blank"> SG-05 2003 MZ. 99 (NO DEFINIDO)</a></td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.01 Nº 190.pdf" target="_blank"> SG-05 2003 MZ.01 Nº 190</a></td>
                    </tr>
                    <tr>
                      <th scope="row">6</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.06 Nº 1275-1277-1278.pdf" target="_blank"> SG-05 2003 MZ.06 Nº 1275-1277-1278</a></td>
                    </tr>
                    <tr>
                      <th scope="row">7</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.07 Nº1275.pdf" target="_blank"> SG-05 2003 MZ.07 Nº1275</a></td>
                    </tr>
                    <tr>
                      <th scope="row">8</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.08 Nº 1275- 1276.pdf" target="_blank"> SG-05 2003 MZ.08 Nº 1275- 1276</a></td>
                    </tr>
                    <tr>
                      <th scope="row">9</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.09 Nº 1463- 1466.pdf" target="_blank"> SG-05 2003 MZ.09 Nº 1463- 1466</a></td>
                    </tr>
                    <tr>
                      <th scope="row">10</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.14 Nº 1389.pdf" target="_blank"> SG-05 2003 MZ.14 Nº 1389</a></td>
                    </tr>
                    <tr>
                      <th scope="row">11</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.24 Nº 1387.pdf" target="_blank"> SG-05 2003 MZ.24 Nº 1387</a></td>
                    </tr>
                    <tr>
                      <th scope="row">12</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.25 Nº 1394-1387.pdf" target="_blank"> SG-05 2003 MZ.25 Nº 1394-1387</a></td>
                    </tr>
                    <tr>
                      <th scope="row">13</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.27 Nº 1866-1395.pdf" target="_blank"> SG-05 2003 MZ.27 Nº 1866-1395</a></td>
                    </tr>
                    <tr>
                      <th scope="row">14</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.28 Nº 1393-1866-1389.pdf" target="_blank"> SG-05 2003 MZ.28 Nº 1393-1866-1389</a></td>
                    </tr>
                    <tr>
                      <th scope="row">15</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.29 Nº 1866-1386-1393.pdf" target="_blank"> SG-05 2003 MZ.29 Nº 1866-1386-1393</a></td>
                    </tr>
                    <tr>
                      <th scope="row">16</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.30 Nº 1866.pdf" target="_blank"> SG-05 2003 MZ.30 Nº 1866</a></td>
                    </tr>
                    <tr>
                      <th scope="row">17</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.31 Nº 1466.pdf" target="_blank"> SG-05 2003 MZ.31 Nº 1466</a></td>
                    </tr>
                    <tr>
                      <th scope="row">18</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.32 Nº 1466.pdf" target="_blank"> SG-05 2003 MZ.32 Nº 1466</a></td>
                    </tr>
                    <tr>
                      <th scope="row">19</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.33 Nº 1466.pdf" target="_blank"> SG-05 2003 MZ.33 Nº 1466</a></td>
                    </tr>
                    <tr>
                      <th scope="row">20</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.34 Nº 1466.pdf" target="_blank"> SG-05 2003 MZ.34 Nº 1466</a></td>
                    </tr>
                    <tr>
                      <th scope="row">21</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.37 Nº 1866.pdf" target="_blank"> SG-05 2003 MZ.37 Nº 1866</a></td>
                    </tr>
                    <tr>
                      <th scope="row">22</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.38 Nº 1466.pdf" target="_blank"> SG-05 2003 MZ.38 Nº 1466</a></td>
                    </tr>
                    <tr>
                      <th scope="row">23</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.39 Nº 1389.pdf" target="_blank"> SG-05 2003 MZ.39 Nº 1389</a></td>
                    </tr>
                    <tr>
                      <th scope="row">24</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.41 Nº 1395.pdf" target="_blank">SG-05 2003 MZ.41 Nº 1395 </a></td>
                    </tr>
                    <tr>
                      <th scope="row">25</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.42 Nº 1395.pdf" target="_blank"> SG-05 2003 MZ.42 Nº 1395</a></td>
                    </tr>
                    <tr>
                      <th scope="row">26</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-05 SANTA ANA/SG-05 2003 MZ.44 Nº 1395.pdf" target="_blank"> SG-05 2003 MZ.44 Nº 1395</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="tab-pane fade" id="descriptionContent4">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ.  67 Nº 1384.pdf" target="_blank"> SG-06 2003 MZ.  67 Nº 1384</a></td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ. 21 Nº 1641.pdf" target="_blank"> SG-06 2003 MZ. 21 Nº 1641</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ. 23 Nº 1684.pdf" target="_blank"> SG-06 2003 MZ. 23 Nº 1684</a></td>
                    </tr>
                    <tr>
                      <th scope="row">4</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ. 24 Nº 1866.pdf" target="_blank"> SG-06 2003 MZ. 24 Nº 1866</a></td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ. 25 Nº 1384-1403-1385.pdf" target="_blank"> SG-06 2003 MZ. 25 Nº 1384-1403-1385</a></td>
                    </tr>
                    <tr>
                      <th scope="row">6</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ. 26 Nº 1473.pdf" target="_blank"> SG-06 2003 MZ. 26 Nº 1473</a></td>
                    </tr>
                    <tr>
                      <th scope="row">7</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ. 27 Nº 1461-1473.pdf" target="_blank"> SG-06 2003 MZ. 27 Nº 1461-1473</a></td>
                    </tr>
                    <tr>
                      <th scope="row">8</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ. 27 Nº 1619.pdf" target="_blank"> SG-06 2003 MZ. 27 Nº 1619</a></td>
                    </tr>
                    <tr>
                      <th scope="row">9</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ. 28 Nº 1404-1473.pdf" target="_blank"> SG-06 2003 MZ. 28 Nº 1404-1473</a></td>
                    </tr>
                    <tr>
                      <th scope="row">10</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ. 29 Nº 1404-1468.pdf" target="_blank"> SG-06 2003 MZ. 29 Nº 1404-1468</a></td>
                    </tr>
                    <tr>
                      <th scope="row">11</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ. 29 Nº 1636.pdf" target="_blank"> SG-06 2003 MZ. 29 Nº 1636</a></td>
                    </tr>
                    <tr>
                      <th scope="row">12</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ. 64 Nº 1384.pdf" target="_blank"> SG-06 2003 MZ. 64 Nº 1384</a></td>
                    </tr>
                    <tr>
                      <th scope="row">13</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ. 65 Nº1873.pdf" target="_blank"> SG-06 2003 MZ. 65 Nº1873</a></td>
                    </tr>
                    <tr>
                      <th scope="row">14</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ. 66 Nº 1384.pdf" target="_blank"> SG-06 2003 MZ. 66 Nº 1384</a></td>
                    </tr>
                    <tr>
                      <th scope="row">15</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ. 68 Nº 1461.pdf" target="_blank"> SG-06 2003 MZ. 68 Nº 1461</a></td>
                    </tr>
                    <tr>
                      <th scope="row">16</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ. 69 Nº 1461.pdf" target="_blank"> SG-06 2003 MZ. 69 Nº 1461</a></td>
                    </tr>
                    <tr>
                      <th scope="row">17</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ.01 Nº454.pdf" target="_blank"> SG-06 2003 MZ.01 Nº454</a></td>
                    </tr>
                    <tr>
                      <th scope="row">18</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ.20 Nº 1227-1641-1637.pdf" target="_blank"> SG-06 2003 MZ.20 Nº 1227-1641-1637</a></td>
                    </tr>
                    <tr>
                      <th scope="row">19</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ.22 Nº 1619-1639.pdf" target="_blank"> SG-06 2003 MZ.22 Nº 1619-1639</a></td>
                    </tr>
                    <tr>
                      <th scope="row">20</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ.23 Nº 1636-1866.pdf" target="_blank"> SG-06 2003 MZ.23 Nº 1636-1866</a></td>
                    </tr>
                    <tr>
                      <th scope="row">21</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ.24 Nº 1873.pdf" target="_blank"> SG-06 2003 MZ.24 Nº 1873</a></td>
                    </tr>
                    <tr>
                      <th scope="row">22</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ.25 Nº 1636.pdf" target="_blank"> SG-06 2003 MZ.25 Nº 1636</a></td>
                    </tr>
                    <tr>
                      <th scope="row">23</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ.26 Nº 1619.pdf" target="_blank"> SG-06 2003 MZ.26 Nº 1619</a></td>
                    </tr>
                    <tr>
                      <th scope="row">24</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ.28 Nº 1620-1619.pdf" target="_blank"> SG-06 2003 MZ.28 Nº 1620-1619</a></td>
                    </tr>
                    <tr>
                      <th scope="row">25</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ.30 Nº 1620.pdf" target="_blank">SG-06 2003 MZ.30 Nº 1620 </a></td>
                    </tr>
                    <tr>
                      <th scope="row">26</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ.31 Nº 1620.pdf" target="_blank"> SG-06 2003 MZ.31 Nº 1620</a></td>
                    </tr>
                    <tr>
                      <th scope="row">27</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ.32 Nº 1467.pdf" target="_blank"> SG-06 2003 MZ.32 Nº 1467</a></td>
                    </tr>
                    <tr>
                      <th scope="row">28</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ.33 Nº 1467-1474-1866.pdf" target="_blank">SG-06 2003 MZ.33 Nº 1467-1474-1866 </a></td>
                    </tr>
                    <tr>
                      <th scope="row">29</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ.34 Nº 1382.pdf" target="_blank"> SG-06 2003 MZ.34 Nº 1382</a></td>
                    </tr>
                    <tr>
                      <th scope="row">30</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 2003 MZ.58 Nº 1866.pdf" target="_blank"> SG-06 2003 MZ.58 Nº 1866</a></td>
                    </tr>
                    <tr>
                      <th scope="row">31</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-06 SAN PEDRO/SG-06 PLANIMETRIA BARRIO SAN PEDRO.pdf" target="_blank"> SG-06 PLANIMETRIA BARRIO SAN PEDRO</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="tab-pane fade" id="descriptionContent5">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07  2003 MZ. 54 Nº 1721.pdf" target="_blank"> SG-07  2003 MZ. 54 Nº 1721</a></td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07  2003 MZ. 55 Nº 1722.pdf" target="_blank"> SG-07  2003 MZ. 55 Nº 1722</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07  2003 MZ. 56 Nº 1848-1835-1844-1722.pdf" target="_blank"> SG-07  2003 MZ. 56 Nº 1848-1835-1844-1722</a></td>
                    </tr>
                    <tr>
                      <th scope="row">4</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07  2003 MZ. 57 Nº 1844.1835-1848.pdf" target="_blank"> SG-07  2003 MZ. 57 Nº 1844.1835-1848</a></td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07  2003 MZ. 58 Nº 1835.pdf" target="_blank"> SG-07  2003 MZ. 58 Nº 1835</a></td>
                    </tr>
                    <tr>
                      <th scope="row">6</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07  2003 MZ. 59 Nº 1834-1833.pdf" target="_blank"> SG-07  2003 MZ. 59 Nº 1834-1833</a></td>
                    </tr>
                    <tr>
                      <th scope="row">7</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07  2003 MZ. 60 Nº 1856.pdf" target="_blank"> SG-07  2003 MZ. 60 Nº 1856</a></td>
                    </tr>
                    <tr>
                      <th scope="row">8</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07  2003 MZ. 61 Nº 1471-1712.pdf" target="_blank">SG-07  2003 MZ. 61 Nº 1471-1712 </a></td>
                    </tr>
                    <tr>
                      <th scope="row">9</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 11 Nº 1720-1721.pdf" target="_blank"> SG-07 2003 MZ. 11 Nº 1720-1721</a></td>
                    </tr>
                    <tr>
                      <th scope="row">10</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 12 Nº 1711.pdf" target="_blank"> SG-07 2003 MZ. 12 Nº 1711</a></td>
                    </tr>
                    <tr>
                      <th scope="row">11</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 13 Nº 1711.pdf" target="_blank"> SG-07 2003 MZ. 13 Nº 1711</a></td>
                    </tr>
                    <tr>
                      <th scope="row">12</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 14 Nº 1848.pdf" target="_blank"> SG-07 2003 MZ. 14 Nº 1848</a></td>
                    </tr>
                    <tr>
                      <th scope="row">13</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 15 Nº 1835.pdf" target="_blank"> SG-07 2003 MZ. 15 Nº 1835</a></td>
                    </tr>
                    <tr>
                      <th scope="row">14</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 16 Nº 1833.pdf" target="_blank"> SG-07 2003 MZ. 16 Nº 1833</a></td>
                    </tr>
                    <tr>
                      <th scope="row">15</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 22 Nº 1710-1716.pdf" target="_blank"> SG-07 2003 MZ. 22 Nº 1710-1716</a></td>
                    </tr>
                    <tr>
                      <th scope="row">16</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 62 Nº 1713-1712 (2).pdf" target="_blank"> SG-07 2003 MZ. 62 Nº 1713-1712 (2)</a></td>
                    </tr>
                    <tr>
                      <th scope="row">17</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 63 Nº 1396-1273-1710.pdf" target="_blank"> SG-07 2003 MZ. 63 Nº 1396-1273-1710</a></td>
                    </tr>
                    <tr>
                      <th scope="row">18</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 70 Nº 1464.pdf" target="_blank"> SG-07 2003 MZ. 70 Nº 1464</a></td>
                    </tr>
                    <tr>
                      <th scope="row">19</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 78 Nº 1719-1871-1856.pdf" target="_blank"> SG-07 2003 MZ. 78 Nº 1719-1871-1856</a></td>
                    </tr>
                    <tr>
                      <th scope="row">20</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 79 Nº 1722-1848.pdf" target="_blank"> SG-07 2003 MZ. 79 Nº 1722-1848</a></td>
                    </tr>
                    <tr>
                      <th scope="row">21</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 80 Nº 1871-1842.pdf" target="_blank"> SG-07 2003 MZ. 80 Nº 1871-1842</a></td>
                    </tr>
                    <tr>
                      <th scope="row">22</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 81 Nº 1871.pdf" target="_blank"> SG-07 2003 MZ. 81 Nº 1871</a></td>
                    </tr>
                    <tr>
                      <th scope="row">23</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 82 Nº 1871-1834.pdf" target="_blank"> SG-07 2003 MZ. 82 Nº 1871-1834</a></td>
                    </tr>
                    <tr>
                      <th scope="row">24</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 83Nº 1854-1856.pdf" target="_blank"> SG-07 2003 MZ. 83Nº 1854-1856</a></td>
                    </tr>
                    <tr>
                      <th scope="row">25</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ. 84 Nº 1471.pdf" target="_blank"> SG-07 2003 MZ. 84 Nº 1471</a></td>
                    </tr>
                    <tr>
                      <th scope="row">26</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ.17 Nº 1835-1833.pdf" target="_blank"> SG-07 2003 MZ.17 Nº 1835-1833</a></td>
                    </tr>
                    <tr>
                      <th scope="row">27</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ.20 Nº 1712-1873.pdf" target="_blank"> SG-07 2003 MZ.20 Nº 1712-1873</a></td>
                    </tr>
                    <tr>
                      <th scope="row">28</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ.21 Nº 1710-1713.pdf" target="_blank"> SG-07 2003 MZ.21 Nº 1710-1713</a></td>
                    </tr>
                    <tr>
                      <th scope="row">29</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-07 PUMACCHUPAN-AV.PARDO-TRES CRUCES/SG-07 2003 MZ.71 Nº 1468.pdf" target="_blank"> SG-07 2003 MZ.71 Nº 1468</a></td>
                    </tr>

                  </tbody>
                </table>
              </div>
              <div class="tab-pane fade" id="descriptionContent6">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR BELEN 2003 MZ. 01 Nº 456.pdf" target="_blank"> SECTOR BELEN 2003 MZ. 01 Nº 456</a></td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR BELEN 2003 MZ.02 Nº 456.pdf" target="_blank"> SECTOR BELEN 2003 MZ.02 Nº 456</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR BELEN 2003 MZ.03 Nº 456.pdf" target="_blank"> SECTOR BELEN 2003 MZ.03 Nº 456</a></td>
                    </tr>
                    <tr>
                      <th scope="row">4</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR BELEN 2003 MZ.04 Nº 455-456.pdf" target="_blank"> SECTOR BELEN 2003 MZ.04 Nº 455-456</a></td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR BELEN 2003 MZ.05 Nº456.pdf" target="_blank"> SECTOR BELEN 2003 MZ.05 Nº456</a></td>
                    </tr>
                    <tr>
                      <th scope="row">6</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR BELEN 2003 MZ.06 Nº455.pdf" target="_blank"> SECTOR BELEN 2003 MZ.06 Nº455</a></td>
                    </tr>
                    <tr>
                      <th scope="row">7</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR BELEN 2003 MZ.07 Nº455.pdf" target="_blank"> SECTOR BELEN 2003 MZ.07 Nº455</a></td>
                    </tr>
                    <tr>
                      <th scope="row">8</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR BELEN 2003 MZ.08 Nº455.pdf" target="_blank"> SECTOR BELEN 2003 MZ.08 Nº455</a></td>
                    </tr>
                    <tr>
                      <th scope="row">9</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR SANTIAGO 2003 MZ. 02 Nº 456.pdf" target="_blank"> SECTOR SANTIAGO 2003 MZ. 02 Nº 456</a></td>
                    </tr>
                    <tr>
                      <th scope="row">10</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR SANTIAGO 2003 MZ.-01 Nº 456.pdf" target="_blank"> SECTOR SANTIAGO 2003 MZ.-01 Nº 456</a></td>
                    </tr>
                    <tr>
                      <th scope="row">11</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR SANTIAGO 2003 MZ.03 Nº456.pdf" target="_blank"> SECTOR SANTIAGO 2003 MZ.03 Nº456</a></td>
                    </tr>
                    <tr>
                      <th scope="row">12</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR SANTIAGO 2003 MZ.04 Nº456.pdf" target="_blank"> SECTOR SANTIAGO 2003 MZ.04 Nº456</a></td>
                    </tr>
                    <tr>
                      <th scope="row">13</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR SANTIAGO 2003 MZ.05 Nº453.pdf" target="_blank"> SECTOR SANTIAGO 2003 MZ.05 Nº453</a></td>
                    </tr>
                    <tr>
                      <th scope="row">14</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR SANTIAGO 2003 MZ.06 Nº453.pdf" target="_blank"> SECTOR SANTIAGO 2003 MZ.06 Nº453</a></td>
                    </tr>
                    <tr>
                      <th scope="row">15</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR SANTIAGO 2003 MZ.07 Nº453.pdf" target="_blank"> SECTOR SANTIAGO 2003 MZ.07 Nº453</a></td>
                    </tr>
                    <tr>
                      <th scope="row">16</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR SANTIAGO 2003 MZ.08 Nº456.pdf" target="_blank"> SECTOR SANTIAGO 2003 MZ.08 Nº456</a></td>
                    </tr>
                    <tr>
                      <th scope="row">17</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SECTOR SANTIAGO 2003 MZ.09 Nº456.pdf" target="_blank"> SECTOR SANTIAGO 2003 MZ.09 Nº456</a></td>
                    </tr>
                    <tr>
                      <th scope="row">18</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SG-08 2003 MZ. 11 Nº452.pdf" target="_blank"> SG-08 2003 MZ. 11 Nº452</a></td>
                    </tr>
                    <tr>
                      <th scope="row">19</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SG-08 2003 MZ.02 Nº454.pdf" target="_blank"> SG-08 2003 MZ.02 Nº454</a></td>
                    </tr>
                    <tr>
                      <th scope="row">20</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SG-08 2003 MZ.03 Nº452.pdf" target="_blank"> SG-08 2003 MZ.03 Nº452</a></td>
                    </tr>
                    <tr>
                      <th scope="row">21</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SG-08 2003 MZ.04 Nº452.pdf" target="_blank"> SG-08 2003 MZ.04 Nº452</a></td>
                    </tr>
                    <tr>
                      <th scope="row">22</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SG-08 2003 MZ.05 Nº367.pdf" target="_blank"> SG-08 2003 MZ.05 Nº367</a></td>
                    </tr>
                    <tr>
                      <th scope="row">23</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SG-08 2003 MZ.06 Nº367.pdf" target="_blank">SG-08 2003 MZ.06 Nº367 </a></td>
                    </tr>
                    <tr>
                      <th scope="row">24</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SG-08 2003 MZ.07 Nº454.pdf" target="_blank"> SG-08 2003 MZ.07 Nº454</a></td>
                    </tr>
                    <tr>
                      <th scope="row">25</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SG-08 2003 MZ.08 Nº367.pdf" target="_blank"> SG-08 2003 MZ.08 Nº367</a></td>
                    </tr>
                    <tr>
                      <th scope="row">26</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SG-08 2003 MZ.09 Nº 367.pdf" target="_blank"> SG-08 2003 MZ.09 Nº 367</a></td>
                    </tr>
                    <tr>
                      <th scope="row">27</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SG-08 2003 MZ.10 Nº 452.pdf" target="_blank"> SG-08 2003 MZ.10 Nº 452</a></td>
                    </tr>
                    <tr>
                      <th scope="row">28</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SG-08 2003 MZ.12 Nº 454.pdf" target="_blank"> SG-08 2003 MZ.12 Nº 454</a></td>
                    </tr>
                    <tr>
                      <th scope="row">29</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SG-08 2003 MZ.13 Nº 454.pdf" target="_blank"> SG-08 2003 MZ.13 Nº 454</a></td>
                    </tr>
                    <tr>
                      <th scope="row">30</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SG-08 2003 MZ.14 Nº1227.pdf" target="_blank"> SG-08 2003 MZ.14 Nº1227</a></td>
                    </tr>
                    <tr>
                      <th scope="row">31</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-08 ALMUDENA-SANTIAGO/SG-08 VISTA GENERAL PUENTE ALMUDENA.pdf" target="_blank"> SG-08 VISTA GENERAL PUENTE ALMUDENA</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="tab-pane fade" id="descriptionContent7">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-09 TOTORA PACCHA-MESA REDONDA-TETEQAQA/SECTOR RECOLETA MZ. 03 Nº 483.pdf" target="_blank"> SECTOR RECOLETA MZ. 03 Nº 483</a></td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-09 TOTORA PACCHA-MESA REDONDA-TETEQAQA/SECTOR RECOLETA MZ.01 Nº0482-0483.pdf" target="_blank"> SECTOR RECOLETA MZ.01 Nº0482-0483</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/SECTORES_GESTION/SG-09 TOTORA PACCHA-MESA REDONDA-TETEQAQA/SECTOR RECOLETA MZ.02 Nº 483.pdf" target="_blank"> SECTOR RECOLETA MZ.02 Nº 483</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="welcome-section pb-100 pb-md-60 pb-sm-40 pt-80 bg-offwhite" style="background-image: url('/assets/img/fondo-rosario.png'); background-size: cover;
    background-position: center;">
  <div class="container">
      <div class="row">
          <!-- Start Section title -->
          <div class="col-lg-6 m-auto text-center">
              <div class="section-title-wrap">
                  <h2>RECOPILACIÓN DE FOTOGRAFÍAS DEL CUSCO 2003 - VISTAS GENERALES</h2>
              </div>
          </div><!-- End Section title -->
      </div>
      <div class="row">
          <div class="col-12">
              <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/ARCO PATA- SAN PEDRO-MELOC.pdf" target="_blank"> ARCO PATA- SAN PEDRO-MELOC</a></td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/AV. PATDO-TULLUMAYO - VIVA EL PERÚ.pdf" target="_blank"> AV. PATDO-TULLUMAYO - VIVA EL PERÚ</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/CHOQUECHACA-PUMACURCO -CARMEN ALTO.pdf" target="_blank"> CHOQUECHACA-PUMACURCO -CARMEN ALTO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">4</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/CHOQUECHACA-TULLUMAYO-SAN BLAS-AV.EL SOL.pdf" target="_blank"> CHOQUECHACA-TULLUMAYO-SAN BLAS-AV.EL SOL</a></td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/DESDE EL MIRADOR.pdf" target="_blank"> DESDE EL MIRADOR</a></td>
                    </tr>
                    <tr>
                      <th scope="row">6</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/DESDE INDEPENDENCIA.pdf" target="_blank"> DESDE INDEPENDENCIA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">7</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/DESDE LA AV. TUPAC AMARU PICCHU - LIMITE CH. AV. EJERCITO-CALLE AV.ALTA-HUMANCHATA.pdf" target="_blank"> DESDE LA AV. TUPAC AMARU PICCHU - LIMITE CH. AV. EJERCITO-CALLE AV.ALTA-HUMANCHATA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">8</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/DESDE PICCHU PARTE ALTA 2.pdf" target="_blank"> DESDE PICCHU PARTE ALTA 2</a></td>
                    </tr>
                    <tr>
                      <th scope="row">9</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/DESDE PICCHU PARTE ALTA -SANTA ANA.pdf" target="_blank"> DESDE PICCHU PARTE ALTA -SANTA ANA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">10</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/DESDE PICCHU PARTE ALTA.pdf" target="_blank"> DESDE PICCHU PARTE ALTA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">11</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/EJE MONUMENTAL DESDE INDEPENDENCIA.pdf" target="_blank"> EJE MONUMENTAL DESDE INDEPENDENCIA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">12</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/PLAZA DE ARMAS-REGOCIJO-SAN FRANCISCO- SAN PEDRO.pdf" target="_blank"> PLAZA DE ARMAS-REGOCIJO-SAN FRANCISCO- SAN PEDRO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">13</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/SAN BLAS.pdf" target="_blank"> SAN BLAS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">14</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/SAN PEDRO -SANTA ANA DESDEPICCHU PARTE ALTA.pdf" target="_blank"> SAN PEDRO -SANTA ANA DESDEPICCHU PARTE ALTA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">15</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/SANTA ANA.pdf" target="_blank"> SANTA ANA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">16</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/TAMBO DE MONTERO.pdf" target="_blank"> TAMBO DE MONTERO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">17</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/VISTA DESDE PICCHU ALTO - SANTA ANA.pdf" target="_blank"> VISTA DESDE PICCHU ALTO - SANTA ANA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">18</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/VISTA PANORAMICA DE LA CIUDAD DEL CUSCO DESDE VIVA EL PERÚ.pdf" target="_blank"> VISTA PANORAMICA DE LA CIUDAD DEL CUSCO DESDE VIVA EL PERÚ</a></td>
                    </tr>
                    <tr>
                      <th scope="row">19</th>
                      <td><a href="assets/pdf/fototeca/cusco_2003/VISTAS_GENERALES/VISTAS GENERALES DESDE CRUZ AQOMOQO 2003 Nº1465-1633.pdf" target="_blank"> VISTAS GENERALES DESDE CRUZ AQOMOQO 2003 Nº1465-1633</a></td>
                    </tr>
                  </tbody>
                </table>
          </div>
      </div>
  </div>
</section>
